import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonProductComponent } from './common-product.component';
import { AddEditcommonProductComponent } from './add-editcommon-product/add-editcommon-product.component';
import { AuthGuard } from 'src/app/core/auth/guards/auth.guard';
import { LeadImportComponent } from './lead-import/lead-import.component';
import { XlMapperComponent } from 'src/app/pages/xl-mapper/xl-mapper.component';
import { LeadDynamicXlComponent } from './lead-dynamic-xl/lead-dynamic-xl.component';

const routes: Routes = [
{ path: '', 
component: CommonProductComponent },
{
  path: 'addlead/:leadId',
  component: AddEditcommonProductComponent,
  canActivate: [AuthGuard]
},

{
  path: 'add-edit-lead/:leadId/:setId',
  component: AddEditcommonProductComponent,
  canActivate: [AuthGuard]
},



{
  path: 'report/:leadId',
  component: CommonProductComponent,
  canActivate: [AuthGuard]
},


{
  path: 'add-edit-leadDetail/:leadId/:setId',
  component: AddEditcommonProductComponent,
  canActivate: [AuthGuard]
},
// {
//   path: 'import-lead',
//   component: LeadImportComponent,
//   canActivate: [AuthGuard]
// },

{
  path: 'import-lead/:setId',
  component: LeadImportComponent,
  canActivate: [AuthGuard]
},

{
  path: 'export-lead',
  component: LeadImportComponent,
  canActivate: [AuthGuard]
},
{
  path: 'xlMapper',
  component: LeadDynamicXlComponent,
  canActivate: [AuthGuard]
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommonProductRoutingModule { }
